import React from "react";

const FilterLayoutContext = React.createContext("bar");

export default FilterLayoutContext;
